import { z } from 'zod';
import { EmptyValidationMessage, FieldValues, Path, RadioCardOption, mapRadioCardsField } from '@ninja/utilities';

export const usePolicyTypeField = <TForm extends FieldValues>() => {
	const getField = ({ field, cards }: { field: Path<TForm>; cards: RadioCardOption<number>[] }) =>
		mapRadioCardsField({
			field,
			size: 'medium',
			cards,
		});

	const getValidation = z.number({
		required_error: EmptyValidationMessage,
	});

	return {
		getField,
		getValidation,
	};
};
